module.exports = __webpack_public_path__ + "img/message_3.2042c8f5.png";